import toUpdateableAreaSubstrate from './to-updateable-area-substrate'

export default toUpdateableAreaSubstrate
